module.exports = __webpack_public_path__ + "static/media/switch_on.77b1c848.png";